import PropTypes from 'prop-types';
import classNames from 'classnames/bind';

import commonStyles from 'styles/common.pcss';

import { Text } from '../../../Text';

import styles from './styles.pcss';
const cx = classNames.bind({ ...styles, ...commonStyles });


export function withLabel(WrappedInput) {
  function InputWithLabel({ label, className, ...otherProps }) {
    return (
      <div className={className}>
        {label && (
          <Text className={cx('label')} isSmall>
            {label}
          </Text>
        )}
        <WrappedInput {...otherProps} />
      </div>
    );
  }

  InputWithLabel.propTypes = {
    label: PropTypes.node,
    ...WrappedInput.propTypes,
  };

  /**
   * Override component name by prepending `Label~`
   * to make it look nice, for example: `LabelTextInput`
   */
  if (process.env.NODE_ENV !== 'production') {
    const WrappedComponentName = WrappedInput.displayName || WrappedInput.name || 'Input';
    InputWithLabel.displayName = `Label${WrappedComponentName}`;
  }

  return InputWithLabel;
}
